<template>
  <v-card class="px-2" color="#133063">
    <div class="tw-text-center tw-py-3 tw-mt-1 tw-relative">
      <span>SIGN UP</span>
      <v-btn class="tw-absolute tw-top-1 tw-right-0" icon @click="$emit('closeModal')">
        <v-icon dark small> mdi-close </v-icon>
      </v-btn>
    </div>

    <v-divider></v-divider>
    <v-container>
      <v-row>
        <v-col>
          <v-alert
            class="tw-cursor-pointer"
            @click="errorMessage = null"
            transition="scale-transition"
            :value="!!errorMessage"
            dense
            text
            outlined
            color="#FB8C00"
          >
            <v-row>
              <v-col class="grow tw-text-left">
                <div>
                  <ul class="tw-list-disc tw-leading-4">
                    <li>
                      <small>{{ errorMessage }}</small>
                    </li>
                  </ul>
                </div>
              </v-col>
            </v-row>
          </v-alert>
          <form @submit.prevent="register">
            <div class="tw-text-left tw-text-sm mb-1">Name</div>
            <v-text-field
              v-model="form.name"
              background-color="white"
              dense
              color="white"
              solo
              filled
              class="rounded-lg"
              light
            ></v-text-field>
            <div class="tw-text-left tw-text-sm mb-1">Email Address</div>
            <v-text-field
              v-model="form.email"
              background-color="white"
              dense
              color="white"
              solo
              filled
              class="rounded-lg"
              light
            ></v-text-field>
            <div class="tw-text-left tw-text-sm mb-1">Password</div>
            <v-text-field
              v-model="form.password"
              background-color="white"
              type="password"
              dense
              color="white"
              solo
              filled
              class="rounded-lg"
              light
            ></v-text-field>
            <div class="tw-text-left tw-text-sm mb-1">Confirm Password</div>
            <v-text-field
              v-model="form.password_confirmation"
              background-color="white"
              type="password"
              dense
              color="white"
              solo
              filled
              class="rounded-lg"
              light
            ></v-text-field>
            <div class="mb-4">
              <v-checkbox
                :error="!acceptForm.agreeTerms && load"
                @change="changeTerms"
                hide-details
                color="white"
                dense
                :rules="[rules.required]"
              >
                <template v-slot:label>
                  <div class="tw-text-xs">
                    I agree to all
                    <a href="#" @click.stop>Terms & Conditions</a> &
                    <a href="#" @click.stop>Privacy Policy.</a>
                  </div>
                </template>
              </v-checkbox>
              <v-checkbox
                :error="!acceptForm.alteast18 && load"
                @change="changeAlteast18"
                hide-details
                color="white"
                dense
                :rules="[rules.required]"
              >
                <template v-slot:label>
                  <span class="tw-text-xs">I am at least 18 years of age.</span>
                </template>
              </v-checkbox>
            </div>
            <div class="mb-3">
              <v-btn
                type="submit"
                color="#d28945"
                width="100%"
                class="tw-text-white mb-2 tw-rounded-full"
                :loading="load"
              >
                Register
              </v-btn>
            </div>
          </form>
          <div class="tw-flex tw-justify-between tw-text-xs mb-2">
            <div></div>
            <div>
              <a href="#" @click="$emit('toLogin')">Login Now</a>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["loginModal"],
  data: () => ({
    errorMessage: null,
    load: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
    acceptForm: {
      agreeTerms: false,
      alteast18: false,
    },
    form: {
      name: "",
      email: "",
      password: "",
      password_confirmation: "",
    },
  }),
  methods: {
    ...mapActions("user", ["attemptRegister"]),
    async register() {
      this.load = true;
      const validate = this.validation();
      if (validate) {
        this.load = false;
        return validate;
      }
      const response = await this.attemptRegister(this.form);
      if (response.data && response.data.success) {
        return location.reload();
      }
      this.errorMessage = response.data.error;
      this.load = false;
    },

    validation() {
      if (!this.acceptForm.agreeTerms || !this.acceptForm.alteast18) {
        return (this.errorMessage = !this.acceptForm.agreeTerms
          ? "Please confirm terms and condition"
          : "Please confirm that you are atleast 18 years old");
      }
      if (this.form.password.length == 0 || this.form.password_confirmation == 0) {
        return (this.errorMessage = "Please enter a password");
      }
      if (this.form.password != this.form.password_confirmation && this.form.password.length > 0) {
        return "Password";
      }
      return null;
    },

    changeTerms(event) {
      this.acceptForm.agreeTerms = event;
    },
    changeAlteast18(event) {
      this.acceptForm.alteast18 = event;
    },
  },
};
</script>

<style></style>
